<template>
  <HubContainer id="branchSuperAdminHub">

    <template v-if="atLeastSuperAdmin">
      <HubSection large icon="icon/hub/organization.svg"
                  :title="$t('branch.title')"
                  :description="$t('branch.description')"
                  :buttonAction="goToOrg">
      </HubSection>

      <HubSection large icon="icon/hub/company.svg"
                  :title="$t('open_online_ordering')"
                  :description="$t('open_online_ordering_description')"
                  :buttonAction="goToOrgWebsite">
      </HubSection>

      <HubSection large icon="icon/hub/global-settings.svg"
                  :title="$t('advanced_navigation.global_settings')"
                  :description="$t('advanced_navigation.global_settings_branch_description')"
                  :buttonAction="goToGlobalSettingsHub">
      </HubSection>

      <HubSection large icon="icon/hub/visual-configuration.svg"
                  :title="$t('style.title')"
                  :description="$t('style.description')"
                  :buttonAction="goToVisualConfigHub">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "branchSuperAdminHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = this.getContextName;
      this.$store.state.pageIcon = "/icon/nav/revenue-center.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      getContextName() {
        if (this.branch) {
          return this.branch.name;
        }
        return "";
      },
      frontendBranchUrl() {
        let contextServer = this.$store.state.contextServer;
        let contextBranch = this.$store.state.contextBranch;

        let serverBaseUrl = contextServer && contextServer.urlFrontend ? contextServer.urlFrontend : 'https://web.ishopfood.com';
        let branchNameCanonical = contextBranch ? contextBranch.nameCanonical : '';

        return `${serverBaseUrl}/#/${branchNameCanonical}`
      }
    },

    methods: {
      goToOrg() {
        this.$router.push(this.$router.buildContext("/branch/edit"));
      },
      goToOrgWebsite() {
        window.open(this.frontendBranchUrl);
      },
      goToGlobalSettingsHub() {
        this.$router.push(this.$router.buildContext("/branch/global-settings-hub"));
      },
      goToVisualConfigHub() {
        this.$router.push(this.$router.buildContext("/visual-config-hub"));
      }
    }
  }
</script>